import { TypedService } from "./TypedService";

export class IntegrationService extends TypedService {

  WorkeraSignIn(ssoLoginUrl: string) {
    return this.redirect(ssoLoginUrl);
  }

}